import { SxProps, Theme } from "@mui/material";

export const checkoutStyles = {
  mainContainer: () => ({
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    position: "relative",
  }),
  contentBox: (isWideScreen: boolean): SxProps<Theme> => ({
    backgroundColor: "#fff",
    maxWidth: "680px",
    margin: isWideScreen ? "auto" : undefined,
    position: "relative",
  }),
  loaderContainer: {
    position: "fixed",
    top: 0,
    zIndex: 999,
    left: 0,
    width: "100%",
    height: "95vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  multiBusinessCheckoutContainer: (theme: Theme) => ({
    fontFamily: theme.typography.fontFamily,
    maxWidth: {
      md: '80vw',
    },
    margin: "auto",
    paddingX: "10px",
  }),

  cardRow: (isScreenBreak: boolean) => ({
    ...(isScreenBreak && {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      overflowX: "auto",
      gap: "0.5rem",
      paddingBottom: "0.5rem",

      scrollbarWidth: "auto",
      "&::-webkit-scrollbar": { height: 8 },
      "&::-webkit-scrollbar-thumb": { backgroundColor: "#ccc", borderRadius: 4 },
      "&::-webkit-scrollbar-track": { backgroundColor: "#ffffff" }
    }),

    ...(!isScreenBreak && {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
      gap: "1rem"
    }),

    marginTop: "20px",
    zIndex: 1,
  }),

  businessCardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  pb20: { paddingBottom: "20px" },

  poweredByContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginY: "20px",
  },
  poweredByText: {
    fontSize: "17px",
    color: "#000",
    fontWeight: 400,
    marginBottom: "2px",
  },

  calendarContainer: {
    pb: '2rem',
    pt: '1rem',
    display: 'flex',
  },

  centeredBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "300px",
  },

  businessItemCardWrapper: {
    flex: "0 0 auto",
    minWidth: 260,
    maxWidth: "88vw",
  },

  businessSectionTitle: {
    mb: 2,
  },

  businessSectionWrapper: {
    mb: 4,
  },
};
